import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Content = /*#__PURE__*/_styled(Typography, true ? {
  target: "e1nnpfoy0"
} : {
  target: "e1nnpfoy0",
  label: "Content"
})(true ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvSW50ZWdyYXRpb25DYXJkL0NvbnRlbnQvQ29udGVudC52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJeUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9JbnRlZ3JhdGlvbkNhcmQvQ29udGVudC9Db250ZW50LnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCBUeXBvZ3JhcGh5IGZyb20gJ0BzZWdtZW50L21hdGNoYS9jb21wb25lbnRzL1R5cG9ncmFwaHknXG5cbmV4cG9ydCBjb25zdCBDb250ZW50ID0gc3R5bGVkKFR5cG9ncmFwaHkpYFxuICBtYXJnaW46IDA7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});